(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var MOBILE_BP = 749;

  function isMobile() {
    return window.innerWidth <= MOBILE_BP;
  }

  function initAccordions(footer) {
    var cols = footer.querySelectorAll('[data-accordion-col]');

    cols.forEach(function (col) {
      var btn   = col.querySelector('.cf-links__heading-btn');
      var panel = col.querySelector('.cf-links__panel');
      if (!btn || !panel) return;

      // Set initial desktop state (panels open)
      if (!isMobile()) {
        panel.style.maxHeight = 'none';
        btn.setAttribute('aria-expanded', 'true');
      } else {
        panel.style.maxHeight = '0';
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.addEventListener('click', function () {
        if (!isMobile()) return; // accordion only on mobile
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          panel.style.maxHeight = '0';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function resetAccordions(footer) {
    var cols = footer.querySelectorAll('[data-accordion-col]');
    cols.forEach(function (col) {
      var btn   = col.querySelector('.cf-links__heading-btn');
      var panel = col.querySelector('.cf-links__panel');
      if (!btn || !panel) return;

      if (!isMobile()) {
        panel.style.maxHeight = 'none';
        btn.setAttribute('aria-expanded', 'true');
      } else {
        // collapse all on resize to mobile
        if (btn.getAttribute('aria-expanded') === 'true') {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      }
    });
  }

  document.querySelectorAll('[id^="custom-footer-"]').forEach(function (footer) {
    initAccordions(footer);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        resetAccordions(footer);
      }, 100);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_latest_article"] && !Shopify.designMode) return;
  try {
    

(function () {
  document.querySelectorAll('.la-section').forEach(function (sectionEl) {
    var buttons      = sectionEl.querySelectorAll('.la-filter__btn');
    var cards        = sectionEl.querySelectorAll('.la-card');
    var grid         = sectionEl.querySelector('.la-grid');
    var loadMoreWrap = sectionEl.querySelector('.la-load-more-wrap');
    var loadMoreBtn  = sectionEl.querySelector('.la-load-more');

    if (!grid) return;

    var displayLimit = parseInt(grid.dataset.displayLimit, 10) || 6;
    var totalCards   = cards.length;
    // currentLimit tracks how many cards are "unlocked" in the ALL view
    var currentLimit = displayLimit;

    var activeTags = new Set(['all']);

    function isTagFiltered() {
      return !activeTags.has('all');
    }

    function updateCards() {
      var filtered = isTagFiltered();

      cards.forEach(function (card) {
        var idx      = parseInt(card.dataset.index, 10);
        var cardTags = (card.dataset.tags || '').trim().split(/\s+/);

        if (filtered) {
          // Tag view: show all matching cards regardless of index
          var match = cardTags.some(function (t) { return t && activeTags.has(t); });
          // Remove overflow class so CSS doesn't block visibility
          card.classList.remove('la-card--overflow');
          card.style.display = match ? '' : 'none';
        } else {
          // ALL view: respect currentLimit
          var visible = idx <= currentLimit;
          // Remove overflow class for revealed cards so CSS doesn't fight inline style
          if (visible) card.classList.remove('la-card--overflow');
          card.style.display = visible ? '' : 'none';
        }
      });

      syncLoadMore();
      // Refresh AOS so newly visible cards get their entrance animation
      if (typeof AOS !== 'undefined') AOS.refresh();
    }

    function syncLoadMore() {
      if (!loadMoreWrap || !loadMoreBtn) return;

      // Hide button entirely when a tag filter is active (all matching cards already shown)
      if (isTagFiltered()) {
        loadMoreWrap.classList.add('la-load-more-wrap--hidden');
        return;
      }

      loadMoreWrap.classList.remove('la-load-more-wrap--hidden');

      if (currentLimit >= totalCards) {
        // Everything is shown — hide the button
        loadMoreWrap.classList.add('la-load-more-wrap--hidden');
        loadMoreBtn.setAttribute('aria-expanded', 'true');
      } else {
        loadMoreBtn.setAttribute('aria-expanded', 'false');
      }
    }

    // Load More click handler
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        // Reveal all remaining cards at once
        currentLimit = totalCards;
        updateCards();
      });
    }

    // Filter button click handlers
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.dataset.tag;

        if (tag === 'all') {
          activeTags.clear();
          activeTags.add('all');
        } else {
          activeTags.delete('all');
          if (activeTags.has(tag)) {
            activeTags.delete(tag);
            if (activeTags.size === 0) activeTags.add('all');
          } else {
            activeTags.add(tag);
          }
        }

        // Sync button visual state
        buttons.forEach(function (b) {
          var active = activeTags.has(b.dataset.tag);
          b.classList.toggle('la-filter__btn--active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        updateCards();
      });
    });

    // Init
    updateCards();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_va_benefits_consult"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(sectionId) {
      var slider   = document.querySelector('[data-slider="' + sectionId + '"]');
      var prevBtn  = document.querySelector('[data-slider-prev="' + sectionId + '"]');
      var nextBtn  = document.querySelector('[data-slider-next="' + sectionId + '"]');
      var dotsWrap = document.querySelector('[data-slider-dots="' + sectionId + '"]');

      if (!slider) return;

      var slides = Array.from(slider.querySelectorAll('.va-benefits-consult__slide'));
      var dots   = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.va-benefits-consult__dot')) : [];
      var total  = slides.length;
      var current = 0;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        if (dots[current]) {
          dots[current].classList.remove('is-active');
          dots[current].setAttribute('aria-selected', 'false');
        }

        current = (index + total) % total;

        slides[current].classList.add('is-active');
        if (dots[current]) {
          dots[current].classList.add('is-active');
          dots[current].setAttribute('aria-selected', 'true');
        }

        // Hide/show arrows if only 1 slide
        if (prevBtn) prevBtn.style.visibility = total <= 1 ? 'hidden' : 'visible';
        if (nextBtn) nextBtn.style.visibility = total <= 1 ? 'hidden' : 'visible';
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });

      // Hide arrows when only 1 slide
      if (total <= 1) {
        if (prevBtn) prevBtn.style.visibility = 'hidden';
        if (nextBtn) nextBtn.style.visibility = 'hidden';
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[id^="va-benefits-consult-"]').forEach(function (el) {
        var id = el.id.replace('va-benefits-consult-', '');
        initSlider(id);
      });
    });

    // Shopify theme editor support
    document.addEventListener('shopify:section:load', function (e) {
      var id = e.detail && e.detail.sectionId;
      if (id) initSlider(id);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
